import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import { Image } from "hesus-ui-kit";
import {
  TextInputLabel,
  PersonInChargeTypeContainer,
  GridRow,
} from "../../PersonInChargeAddEdit.styled";

import "./PersonInChargeSearchBox.css";

const PersonInChargeSearchBox = (props) => {
  const { t, formData, setFormData, adminList, title, type, icon } = props;
  const [selectedMainAdmins, setSelectedMainAdmins] = useState(null);
  const [selectedSubAdmins, setSelectedSubAdmins] = useState([]);
  const [isAdminSuggestionsLoading, setAdminSuggestionsLoading] =
    useState(false);
  const [adminMainList, setAdminMainList] = useState([]);
  const [adminSubstituteList, setAdminSubtituteList] = useState([]);

  const onMainListChange = (value) => {
    if (value) {
      setSelectedMainAdmins(adminList.find((item) => item.id === value.id));
      setAdminSubtituteList(adminList.filter((item) => item.id !== value.id));
      const subIndex = selectedSubAdmins.findIndex(
        (item) => item.id === value.id
      );

      subIndex !== -1 &&
        setAdminSubtituteList(adminSubstituteList.splice(subIndex, 1));
    } else {
      setSelectedMainAdmins(null);
      setAdminMainList(adminList);
      setAdminSubtituteList(adminList);
    }
  };

  const onsubListChange = (value) => {
    const subIds = value.map((item) => item.id);
    // let subList = adminList.filter((items) => subIds.includes(items.id));
    setSelectedSubAdmins(value);

    const mainList = adminList.filter((items) => !subIds.includes(items.id));
    setAdminMainList(mainList);
    if (selectedMainAdmins) {
      const subIndex = selectedSubAdmins.findIndex(
        (item) => item.id === selectedMainAdmins.id
      );
      subIndex !== -1 && setSelectedMainAdmins(null);
    }
  };

  useEffect(() => {
    const initData = formData[`${type}`];
    if (initData) {
      let selectedIds = [];
      if (initData?.substitutes)
        selectedIds = initData.substitutes.map((item) => item.id);
      if (initData.main) selectedIds.push(initData.main?.id);
      if (selectedIds) {
        let newList = adminList.filter(
          (items) => !selectedIds.includes(String(items.id))
        );
        setAdminMainList(newList);
        setAdminSubtituteList(newList);
        setSelectedSubAdmins(initData?.substitutes);
        setSelectedMainAdmins(initData?.main);
      }
    } else {
      setAdminMainList(adminList);
      setAdminSubtituteList(adminList);
    }
  }, [adminList]);

  useEffect(() => {
    setFormData({
      ...formData,
      [`${type}`]: {
        id: formData[`${type}`]?.id ? formData[`${type}`]?.id : 0,
        main: selectedMainAdmins,
        substitutes: selectedSubAdmins,
      },
    });
  }, [selectedSubAdmins, selectedMainAdmins]);

  return (
    <PersonInChargeTypeContainer>
      <GridRow column="40px auto">
        <Image styles={{ width: "40px" }} src={icon} />
        <TextInputLabel>
          {" "}
          {t(`${title}`)}
          {isAdminSuggestionsLoading && (
            <ClipLoader size={15} background="#15aee5 !important" />
          )}
        </TextInputLabel>
      </GridRow>

      <Autocomplete
        id="tags-outlined"
        options={adminMainList}
        getOptionLabel={(option) =>
          `${option.firstName || ""} ${option.lastName || ""}`.trim()
        }
        style={{ zIndex: 99, maxWidth: "75%", marginLeft: "40px" }}
        filterSelectedOptions
        renderInput={(params) => <TextField {...params} placeholder="" />}
        value={selectedMainAdmins}
        onChange={(event, newValue) => {
          onMainListChange(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      <Autocomplete
        multiple
        id="tags-outlined"
        options={adminSubstituteList}
        getOptionLabel={(option) =>
          `${option.firstName || ""} ${option.lastName || ""}`.trim()
        }
        style={{ zIndex: 99, marginLeft: "40px" }}
        filterSelectedOptions
        renderInput={(params) => <TextField {...params} placeholder="" />}
        value={selectedSubAdmins}
        onChange={(event, newValue) => {
          // Check if 'All' option is clicked
          if (newValue.find((option) => option.id === 0)) {
            // Check if all options are selected
            if (usersOptions.length === selectedSubAdmins.length) {
              setAdminSubtituteList([]);
            } else {
              onsubListChange(usersOptions);
            }
          } else {
            onsubListChange(newValue);
          }
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
    </PersonInChargeTypeContainer>
  );
};

PersonInChargeSearchBox.propTypes = {
  t: PropTypes.func.isRequired,
};
PersonInChargeSearchBox.defaultProps = {};
export default withTranslation()(PersonInChargeSearchBox);
